export enum UnitStatus {
  AVAILABLE = "available",
  SOLD = "sold",
  NOT_RELEASED = "not released",
  RESERVED = "reserved",
}
export interface IUnit {
  block: string;
  createdAt: string;
  currency: string;
  deletedAt: string | null;
  floor: number;
  floorPlanId: string;
  id: string;
  name: string | null;
  price: number;
  projectId: string;
  remarks: string;
  status: string;
  transactionId: string | null;
  updatedAt: string;
}
export interface IUnitDTO {
  name: string;
  price: string;
  status: "sold" | "available" | "not released" | "reserved";
  projectId?: string;
  floorPlanId?: string;
}
